import React from 'react'
import { Box, Typography } from '@mui/material'
import Icon from '../../utils/icons'
import { downloadFile } from '../../utils/fileUtils'
import { useStyles } from './style'

function PdfViewer(props) {
  const classes = useStyles()
  const { selectedPdf } = props

  return (
    <Box className={classes.pdfViewerWrapper}>
      <iframe src={selectedPdf.fileUrl ? `${selectedPdf.fileUrl}#toolbar=0` : ''} width="100%" height="518px" />
      {selectedPdf.fileUrl &&
        <Box className={classes.downloadButton} onClick={() => downloadFile(selectedPdf.fileUrl, 'blank')}>
          <Icon src="download" />
          <Typography>Download Application</Typography>
        </Box>
      }
    </Box>
  )
}

export default PdfViewer
